import React, { useState, useContext } from "react";
import axios from "axios";
import PopupReagendamientoReservada from "../Popup/popupReagendamientoReservada";
import { FormContext } from "../../context/FormContext"; 

const ResumenReagendamiento = ({ datosReserva, prevStep, nextStep , goToSubStep}) => {
  // console.log("Received datosReserva prop:", datosReserva);
  // console.log("datos datosReserva", datosReserva?.datos_reserva);
  const { formData } = useContext(FormContext)
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleResumenSubmit = async () => {
    setIsLoading(true);
    const url = process.env.REACT_APP_API_URL_REAGENDAR_CITA;
    // console.log("datosReserva ", datosReserva);
    const formDataReagendar = {
      ...datosReserva?.datos_reserva,
      accion: 2,
    };

    try {
      const response = await axios.post(url, formDataReagendar, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_BEARER_TOKEN}`,
          "Content-Type": "application/json",
        },
      });
      // console.log("data enviada al endpoint", formDataReagendar);
      // console.log("response", response);

      if (response?.data?.message?.success) {
        setPopupMessage("Reagendamiento realizado correctamente!");
      } else {
        setPopupMessage(
          response?.data?.message || "Hubo un problema con la solicitud."
        );
      }
      setShowPopup(true);
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
      setPopupMessage("Hubo un problema al procesar la solicitud.");
      setShowPopup(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };
  return (
    <div className="row" id="booking">
      <div className="container">
        <div className="row mb40" id="booking-step-back">
          <button
           onClick={() => goToSubStep(1)}
           className="btn btn-secondary">
            <i className="fa fa-long-arrow-left"></i> &nbsp; VOLVER
          </button>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-9 pads0-768" id="search-appointment">
            <div className="row" id="search-resume-container">
              {isLoading && (
                <div className="loading-overlay">
                  <div className="spinner"></div>
                </div>
              )}

              <div className="col-12 pads0">
                <div className="col-12 text-center mb20">
                  <h3
                   className={`h3-less
                    ${formData?.cadena === "eco" ? "eco-theme-text" : ""}
                    ${formData?.cadena === "gmo" ? "gmo-theme-text" : ""}
                    `}
                   
                   >
                    
                    Resumen de la reserva</h3>
                </div>

                <div className="col-12 pads0" id="patient-search">
                  <div className="row mb20" id="patient-search-store">
                    <div className="col-12 pads0 mb20">
                      <div className="resume-bar">
                        <b>Tienda Seleccionada</b>
                      </div>
                    </div>
                    <div className="col-md-6 pads0 mb10-768">
                      <div className="row">
                        <div className="col-12">
                          <h6 className="monts-b upper">
                            {datosReserva?.datos_tienda?.descripcion}
                          </h6>
                          <p className="mb0">
                            {datosReserva?.datos_tienda?.direccion}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 align-self-center text-center">
                      <a
                        href={
                          datosReserva?.datos_tienda?.cfg_latitud &&
                          datosReserva?.datos_tienda?.cfg_longitud // Verificar que ambas coordenadas existan
                            ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                `${datosReserva?.datos_tienda?.cfg_latitud.replace(
                                  ",",
                                  "."
                                )},${datosReserva?.datos_tienda?.cfg_longitud.replace(
                                  ",",
                                  "."
                                )}`
                              )}`
                            : "#"
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => {
                          if (
                            !datosReserva?.datos_tienda?.cfg_latitud ||
                            !datosReserva?.datos_tienda?.cfg_longitud
                          ) {
                            e.preventDefault(); // Evitar que el enlace intente navegar si no hay coordenadas válidas
                            console.warn(
                              "Las coordenadas no están disponibles."
                            );
                          }
                        }}
                      >
                        {" "}
                        <p className="text-switch monts-sb blue-bord upper inline-b mb0">
                          Cómo Llegar
                        </p>
                      </a>
                    </div>
                  </div>

                  <div className="row mb-40" id="patient-search-1">
                    <div className="col-12 pads0 mb20">
                      <div className="resume-bar">
                        <b>
                          Reserva de{" "}
                          {datosReserva?.datos_reserva?.int_pnombre || "N/A"}{" "}
                          {datosReserva?.datos_reserva?.int_apaterno || ""}
                        </b>
                      </div>
                    </div>
                    <div className="col-md-6 pads0 mb20 mb0-768">
                      <div className="row">
                        <div className="col-12 mb20">
                          <h6 className="monts-b upper">
                            Propósito de la visita
                          </h6>
                          <p className="mb0 desc-ovw-type">
                            {datosReserva?.nombre_servicio}
                          </p>
                        </div>
                        <div className="col-12 mb20 mb0-768">
                          <h6 className="monts-b upper">Fecha y Hora</h6>
                          <p className="mb0 desc-ovw-date">
                            <span className="date-month">
                              {datosReserva?.datos_reserva?.rsa_fecha ||
                                "Fecha no disponible"}
                              &nbsp;
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb20">
                      <h6 className="monts-b upper">
                        Información del paciente
                      </h6>
                      <p className="mb0">
                        <strong>Nombre:</strong>{" "}
                        {datosReserva?.datos_reserva?.int_pnombre || "N/A"}{" "}
                        {datosReserva?.datos_reserva?.int_apaterno || ""}
                      </p>
                      <p className="mb0">
                        <strong>Teléfono:</strong>{" "}
                        {datosReserva?.datos_reserva?.int_telefono ||
                          "No disponible"}
                      </p>
                      <p className="mb0">
                        <strong>Correo: </strong>{" "}
                        {datosReserva?.datos_reserva?.int_email ||
                          "No disponible"}
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    {/* Reschedule Section */}
                    <div
                      className="col-12 resch-selection-box text-center"
                      style={{ display: "block" }}
                    >
                      <div className="row justify-content-center">
                        <div className="col-md-8 mb40 col-12 pads5">
                          <div
                            onClick={handleResumenSubmit}
                            className={`cancel-ev-button src-button upper 
                              ${formData?.cadena === "eco" ? "eco-theme-button" : ""}
                              ${formData?.cadena === "gmo" ? "gmo-theme-button" : ""}
                              `}
                          >
                            Sí, reagendar
                          </div>
                        </div>

                        <div className="col-md-9 mt20 text-center">
                          <p>
                            <b>Gracias por confiar</b>
                            <br />
                            Tu salud visual es importante para nosotros
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Cancel Section */}
                    <div className="col-12 cancel-selection-box text-center">
                      <div className="row justify-content-center">
                        <div className="col-md-8 mb40 col-12 pads5">
                          <button
                            onClick={handleResumenSubmit}
                            className={`cancel-ev-button src-button upper 
                              ${formData?.cadena === "eco" ? "eco-theme-button" : ""}
                              ${formData?.cadena === "gmo" ? "gmo-theme-button" : ""}
                              `}
                          >
                            Sí, anular
                          </button>
                        </div>
                        <div className="col-md-9 mb10">
                          <p>
                            Si quieres <b>reagendar</b> puedes encontrar los{" "}
                            <b>
                              nuevos horarios disponibles en los siguientes
                              links
                            </b>
                            :
                          </p>
                        </div>
                        <div className="col-md-4 col-6 pads5">
                          <button className="resch-ev-button src-button upper">
                            Reagendar Examen Visual
                          </button>
                        </div>
                        <div className="col-md-4 col-6 pads5">
                          <button className="resch-ev-button src-button upper">
                            {/* Reagendar Contactología */}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Indicador de carga */}
      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}

      {showPopup && <PopupReagendamientoReservada message={popupMessage} id_reserva={datosReserva?.datos_reserva?.rsa_codigo}/>}
    </div>
  );
};

export default ResumenReagendamiento;
